import React, { useRef } from 'react'

import {
  CheckCircleIcon,
  MinusCircleIcon,
  QuestionMarkCircleIcon,
  XCircleIcon,
} from '@heroicons/react/20/solid'
import { ClipboardDocumentListIcon, XMarkIcon } from '@heroicons/react/24/outline'
import ReactTooltip from 'react-tooltip'

import { AuditResults } from './AuditResults'

export function DealAudit() {
  const modalRef = useRef<HTMLDialogElement>(null)
  const showModal = () => modalRef.current?.showModal()
  const closeModal = () => modalRef.current?.close()

  return (
    <>
      <button
        className='btn btn-ghost btn-sm rounded'
        data-tip='Global Audit Check'
        data-for='audit-check'
        onClick={showModal}
      >
        <ClipboardDocumentListIcon
          width={25}
          height={25}
          strokeWidth={1}
          className='text-indigo-900'
        />
      </button>
      <ReactTooltip
        id='audit-check'
        place='left'
        effect='solid'
      />

      <dialog
        role='dialog'
        ref={modalRef}
        className='backdrop:bg-gray-900 backdrop:bg-opacity-30 rounded-md p-0 w-3/6'
        aria-modal='true'
      >
        <header className='bg-blue-100 px-5 py-3 flex gap-3 items-center text-gray-700'>
          <div className='flex-grow font-semibold'>Global Audit Check</div>
          <button onClick={closeModal}>
            <XMarkIcon
              width={22}
              height={22}
              className='text-indigo-900'
            />
          </button>
        </header>

        <main className='px-5 py-3 min-h-[200px]'>
          <AuditResults />
        </main>

        <footer className='px-5 py-3 flex gap-3 items-center text-gray-700'>
          <ul className='flex gap-10 mx-auto text-sm bg-gray-50 rounded-full shadow px-10 py-3 my-3'>
            <li className='flex flex-col items-center'>
              <QuestionMarkCircleIcon
                width={22}
                height={22}
                className='text-blue-400'
              />
              <span>Data</span>
              <span>Unavailable</span>
            </li>
            <li className='flex flex-col items-center'>
              <CheckCircleIcon
                width={22}
                height={22}
                className='text-green-600 mb-1'
              />
              <span>Audited</span>
              <span className='font-semibold'>Match</span>
            </li>
            <li className='flex flex-col items-center'>
              <XCircleIcon
                width={22}
                height={22}
                className='text-red-500 mb-1'
              />
              <span>Audited</span>
              <span className='font-semibold'>Mismatch</span>
            </li>
            <li className='flex flex-col items-center'>
              <MinusCircleIcon
                width={22}
                height={22}
                className='text-gray-400 mb-1'
              />
              <span>Not</span>
              <span>Required</span>
            </li>
          </ul>
        </footer>
      </dialog>
    </>
  )
}
